// @ts-nocheck

/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@kubb/plugin-client/clients/axios";
import type { DemoProtectedActionDemoRbacProtectedActionPostMutationResponse } from "../models/demoController/DemoProtectedActionDemoRbacProtectedActionPost.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/axios";

function getDemoProtectedActionDemoRbacProtectedActionPostUrl() {
  const res = { method: 'POST', url: `/demo/rbac/protected-action` as const }
  return res
}

/**
 * @description Demo endpoint that requires owner role.
 * Use this to test permission checks - only owners can execute this action.
 * @summary Demo Protected Action
 * {@link /demo/rbac/protected-action}
 */
export async function demoProtectedActionDemoRbacProtectedActionPost(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DemoProtectedActionDemoRbacProtectedActionPostMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getDemoProtectedActionDemoRbacProtectedActionPostUrl().url.toString(), ... requestConfig })
  return res.data
}